<template>
  <div class="input-stepper">
    <IconButton variant="outline" size="medium" icon="minus" aria-label="decrease" @click="decrease" />
    <span class="value">{{ model }}</span>
    <IconButton variant="outline" size="medium" icon="plus" aria-label="increase" @click="increase" />
  </div>
</template>

<script setup lang="ts">
import IconButton from './icon-button.vue';

const model = defineModel<number | null>({ default: 0 });
const props = withDefaults(defineProps<{ min?: number | null; max?: number | null }>(), {
  min: 0,
  max: 9999,
});

function increase() {
  const value = model.value ?? 0;

  if (props.max && value >= props.max) {
    return;
  }

  model.value = value + 1;
}

function decrease() {
  const value = model.value ?? 0;

  if (props.min !== null && value <= props.min) {
    return;
  }

  model.value = value - 1;
}
</script>

<style scoped lang="scss">
.input-stepper {
  display: inline-flex;
  align-items: center;
  vertical-align: top;
}

.value {
  width: var(--t-spacing-xl);
  text-align: center;
}
</style>
